/* eslint-disable no-console */
import React, { useState } from 'react';
import { Button, Input, SvgIcon, makeStyles } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import propTypes from 'prop-types';
import MessageBox from './MessageBox';
import SendIcon from '@material-ui/icons/Send';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import ClearIcon from '@material-ui/icons/Clear';

const useStyles = makeStyles({
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '1%',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
  },
  input: {
    flex: 1,
    fontSize: '16px',
    height: '32px',
    outline: 'none',
    textUnderlineOffset: 'none',
    border: 'none',
    width: '100%',
  },
  button: {
    margin: '0 8px',
  },
  sendIcon: {
    margin: '0 8px',
    fill: 'black',
    transition: 'fill 0.2s',
    '&:hover': {
      fill: '#00bfff',
    },
  },
});

const InputMessage = ({
  setTypeMessage,
  setSelectedFile,
  selectFile,
  disabled,
  onSendMessage,
  enableFiles,
}) => {
  const [newMessage, setNewMessage] = useState('');
  const [selectedFileToSend, setSelectedFileToSend] = useState(null);
  const classes = useStyles();

  const sendMessage = () => {
    const messageToSend = newMessage;
    setNewMessage('');
    onSendMessage({ message: messageToSend });
  };
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };
  const handleButtonPressImage = () => {
    sendMessage();
    setSelectedFileToSend(null);
    enableFiles(false);
  };
  const handleDeleteInputButton = () => {
    setNewMessage('');
    setSelectedFile(null);
    setSelectedFileToSend(null);
    enableFiles(false);
  };
  const handleFileInput = async (event) => {
    try {
      const file = event.target.files[0];
      const allowedImageFormats = ['.jpg', '.png', '.jpeg', 'bmp'];
      const allowedFileFormats = ['.pdf'];
      if (file) {
        const fileExtension = `.${file.name.split('.').pop()}`;

        if (allowedImageFormats.includes(fileExtension)) {
          setSelectedFile(file);
          setSelectedFileToSend(file);
          setTypeMessage('image');
          setNewMessage('IMAGEN RECIBIDA');
        } else if (allowedFileFormats.includes(fileExtension)) {
          setSelectedFile(file);
          setSelectedFileToSend(file);
          setTypeMessage('file');
          setNewMessage('ARCHIVO RECIBIDO');
        } else {
          setNewMessage('');
          setSelectedFile(null);
          setSelectedFileToSend(null);
          enableFiles(false);
          event.target.value = null;
        }
      }
    } catch (error) {
      console.log('handleFileInput error', error);
      setNewMessage('');
      setSelectedFile(null);
      setSelectedFileToSend(null);
      enableFiles(false);
      event.target.value = null;
    }
  };

  return selectFile ? (
    <MessageBox disabled={disabled}>
      <Input type="file" onChange={handleFileInput} className={classes.input} />
      {selectedFileToSend ? (
        <>
          <Button onClick={handleDeleteInputButton}>
            <DeleteIcon />
          </Button>
          <SvgIcon
            onClick={handleButtonPressImage}
            className={classes.sendIcon}
            component={SendIcon}
          />
        </>
      ) : (
        <Button onClick={() => enableFiles(false)}>
          <ClearIcon />
        </Button>
      )}{' '}
    </MessageBox>
  ) : (
    <MessageBox className={classes.inputContainer} disabled={disabled}>
      <Input
        type="text"
        placeholder="Escribe un mensaje ..."
        value={newMessage}
        onChange={(e) => {
          setNewMessage(e.target.value);
        }}
        onKeyDown={handleKeyPress}
        className={classes.input}
        autoCorrect="off"
        disableUnderline
      />
      <Button onClick={() => enableFiles(true)} className={classes.button}>
        <AttachFileIcon />
      </Button>
      <SvgIcon onClick={sendMessage} className={classes.sendIcon} component={SendIcon} />
    </MessageBox>
  );
};

InputMessage.propTypes = {
  setTypeMessage: propTypes.func.isRequired,
  setSelectedFile: propTypes.func.isRequired,
  disabled: propTypes.bool,
  selectFile: propTypes.bool,
  onSendMessage: propTypes.func.isRequired,
  enableFiles: propTypes.func.isRequired,
};

export default InputMessage;
